import React from "react";
import PropTypes from 'prop-types';
import MyInput from '../../components/controls/MyInput';
import _AdminService from "../../modules/AdminService";
import moment from "moment";
import { Spin, Collapse, Tag, Button } from "antd";
import ButtonComponent from 'components/controls/Button';
import _notification from 'modules/notification';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import EmptyState from 'components/enterprise/EmptyState';
const { Panel } = Collapse;

class CandidateAssignedList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pagination: { pageSize: 999999, current: 1, total: 0 },
            totalRowCount: 0,
            selectedRowKeys: [],
            loading: true,
            readOnly: false,
            selectAll: false
        };
    }

    componentDidMount() {
        this.getAssignedStudentByCenterAndBatch();
    }

    getAssignedStudentByCenterAndBatch = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    const params = {
                        CenterID: this.props.popupData.Center_Id,
                        BatchID: this.props.popupData.Id,
                    }
                    let readOnlyTemp = false;                   

                    let candidateList = await _AdminService.GetAssignedStudentByCenterAndBatch(this.state.pagination.pageSize, params);

                    //console.log("candidateList Data: ", candidateList.data);
                    // console.log(this.state.data ? [...new Set(candidateList.data.List.map(item => item.Category ? item.Category : "A"))] : []);

                    let searchedData = candidateList.data;
                    if ('readOnly' in this.props.popupData) {
                        readOnlyTemp = true;
                        searchedData.List.sort(this.sortByProperty("Roll_Number"));
                    }
                    else{
                        searchedData.List.sort(this.sortByProperty("Form_Number"));
                    }
                    

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        totalRowCount: searchedData.TotalRecords,
                        readOnly: readOnlyTemp,
                        loading: false,
                        selectedRowKeys: [],
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    sortByProperty(property) {
        return function (a, b) {
            if (a[property] > b[property])
                return 1;
            else if (a[property] < b[property])
                return -1;

            return 0;
        }
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    //console.log("Application ID: ", this.props.popupData);
                    // let response = await _AdminService.GetStudentDataForReview(this.props.popupData.Application_Id);
                    // console.log("Summary Data:  ", response.data);
                    this.setState({
                        data: [],
                        loading: false
                    });

                } catch (e) {
                    // TODO 
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onRemoveFromBatch = (value) => {
        //console.log('Student status: ', value);

        const params = {
            StudentIds: this.state.selectedRowKeys,
            Center_Id: 0,
            ClassRoom_Id: 0,
        }

        if (value != undefined)
            params.StudentIds = [value.Id];

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.RemoveStudentFromCenterAndBatch(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Candidate removed from Center and Batch successfully.");
                        this.setState({
                            loading: false,
                            selectedRowKeys: [],
                            selectAll: false                            
                        });
                        this.getAssignedStudentByCenterAndBatch();
                        this.props.onCandidateDeallocation();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    };

    onHtmlSelectAll = (e) => {

        //console.log('value of checkbox : ', e.target.checked);

        //this.setState({ selectedRowKeys: this.state.data.map(a => a.Id) });
        var myTable = document.getElementById('candidateAssignedList');
        let cbox = myTable.querySelectorAll("input[type='checkbox']");

        for (var i = 1; i < cbox.length; i++) {
            cbox[i].checked = e.target.checked;
        }

        if (e.target.checked) {
            this.setState({ selectedRowKeys: this.state.data.map(a => a.Id), selectAll: !this.state.selectAll });
        }
        else {
            this.setState({ selectedRowKeys: [], selectAll: !this.state.selectAll });
        }

    }

    onHtmlSelectRow = studentID => {
        console.log(studentID);
        let tempKeys = this.state.selectedRowKeys;
        if (tempKeys.includes(studentID)) {
            this.setState({ selectedRowKeys: tempKeys.filter((value) => value != studentID) });
        }
        else {
            tempKeys.push(studentID);
            this.setState({ selectedRowKeys: tempKeys });
        }
    }

    render() {
        // if (this.state.loading)
        //     return <Spin size="large" />

        return (
            <div className="admin-home">
                {this.state.loading && <Spin size="large" />}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px' }}>Center:
                        <span className="admin-primary-text" style={{ fontWeight: 'bold', fontSize: '14px' }}> {this.props.popupData.CenterName}</span>
                    </label>
                    <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px', marginLeft: '20px' }}>Batch:
                        <span className="admin-primary-text" style={{ fontWeight: 'bold', fontSize: '14px' }}> {this.props.popupData.Name}</span>
                    </label>
                    <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px', marginLeft: '20px' }}>Assigned Count:
                        <span className="admin-primary-text" style={{ fontWeight: 'bold', fontSize: '14px' }}> {this.state.totalRowCount}</span>
                    </label>

                    {!this.state.readOnly ? <></> :
                        <>
                            <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px', marginLeft: '20px' }}>Start Roll No.:
                                <span className="admin-primary-text" style={{ fontWeight: 'bold', fontSize: '14px' }}> {this.props.popupData.Start_Roll_Number}</span>
                            </label>

                            <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px', marginLeft: '20px' }}>End Roll No.:
                                <span className="admin-primary-text" style={{ fontWeight: 'bold', fontSize: '14px' }}> {this.props.popupData.End_Roll_Number}</span>
                            </label>
                        </>
                    }

                    {this.state.selectedRowKeys.length > 0 ?
                        <Tag
                            id="btnPrint"
                            type="button" size="small"
                            style={{ marginLeft: "30px", marginRight: "60px" }}
                            onClick={(event) => this.onRemoveFromBatch()}
                            color="var(--color-error)" >Remove {this.state.selectedRowKeys.length} Selected</Tag> : <></>}
                </div>

                <div className=" analysisWrap customTableCandidateAssignDivWrapper admin-custom-table" >
                     <div className="custom-table-wrap  admin-table table-striped-rows">
                        <div className=" analysisWrap ant-table-small" >
                            <div className="ant-table-content">
                                <div className="ant-table-body m-0">
                                    <table className='customTable table-striped-rows whiteBg' id="candidateAssignedList">
                                        <thead className="ant-table-thead"> 
                                            <tr className='stickyDiv'>
                                                {this.state.readOnly ? <></> : <th style={{ width: '2%' }} ><input type="checkbox" checked={this.state.selectAll} className='customTableAllCheckbox' onClick={this.onHtmlSelectAll.bind(this)} /></th>}

                                                <th style={{ width: '5%' }}>Form #</th>
                                                {!this.state.readOnly ? <></> : <th style={{ width: '5%' }} >Roll No.</th>}
                                                <th style={{ width: '19%' }}>Name</th>
                                                <th style={{ width: '10%' }}>Applied Post</th>
                                                <th style={{ width: '5%' }}>Gender Age</th>
                                                <th style={{ width: '9%' }}>Center</th>
                                                <th style={{ width: '7%' }}>Batch</th>
                                                <th style={{ width: '7%' }}>State</th>
                                                <th style={{ width: '7%' }}>District</th>
                                                <th style={{ width: '7%' }}>Taluka</th>
                                                {this.state.readOnly ? <></> : <th style={{ width: '7%' }}>Action</th>}
                                            </tr>
                                        </thead>
                                        <tbody  className='ant-table-tbody '>
                                            {this.state.data.map((item, index) => (

                                                <tr data-index={index} key={item.Id} draggable>
                                                    {this.state.readOnly ? <></> : <td><input type="checkbox" className='customTableCellCheckbox' onClick={(enent) => this.onHtmlSelectRow(item.Id)} /></td>}
                                                    <td>{item.Form_Number}</td>
                                                    {!this.state.readOnly ? <></> : <td style={{fontWeight : "bold"}} >{item.Roll_Number}</td>}
                                                    <td>{item.First_Name + ' ' + item.Middle_Name + ' ' + item.Last_Name}</td>
                                                    <td>{item.Applied_Post}</td>
                                                    <td><label style={{ fontSize: '13px', textAlign: 'left', alignContent: 'center', color: 'var(--color-neutral)' }}>{item.Gender} <br /> {moment().diff(item.Birth_Date, 'years')} yrs</label></td>
                                                    <td>{item.CenterName}</td>
                                                    <td>{item.ClassRoomName}</td>
                                                    <td>{item.State}</td>
                                                    <td>{item.District}</td>
                                                    <td>{item.Taluka}</td>
                                                    {this.state.readOnly ? <></> : <td>
                                                        {item.Is_Submitted ?
                                                            <Tag onClick={(event) => this.onRemoveFromBatch(item)} style={{ fontSize: '10px', height: '25px' }}
                                                                color={"var(--color-error)"}>
                                                                {item.Is_Approved_Rejected == 0 ? "Review" : (item.Is_Approved_Rejected == 1 ? "Remove from Batch" : "Rejected")}
                                                            </Tag> : <></>}
                                                    </td>}

                                                </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {!this.state.data.length ?
                                        <EmptyState icon="inbox" title="No records found" />
                                        : ""}
                                </div>
                                <div className="ant-table-footer m-0">
    
                                        <div className="d-flex align-items-center justify-content-end">
                                            {this.state.selectedRowKeys.length ?
                                            <label style={{  marginRight: '20px', color: 'var(--color-success)' }}>Selected Records: {this.state.selectedRowKeys.length}</label>
                                            : <></>}
                                            <label style={{  marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>        
                                        </div> 
                                    
                                </div>
                            
                            </div>
                        </div>
                        
                        
                    </div>       
                </div>
            </div>
        );
    }
}

export default CandidateAssignedList;

// 0 - Not Submitted                (Student is filling his form)
// 1 - Approved                     (Reviewed by reviewer and approved)
// 2 - Rejected                     (Form rejected and Provided reason for rejection
